import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/women-education-program.webp'
import _imports_1 from '../assets/children-education-program.webp'
import _imports_2 from '../assets/food-home-children.webp'


const _withScopeId = n => (_pushScopeId("data-v-ddb4751c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "first scroll-to" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "WHAT WE DO")
  ]),
  /*#__PURE__*/_createElementVNode("article", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Our empowerment programs provides marginalized women and children with the opportunity to come together in classes to learn, build support networks, share experiences, to learn critical skills, and to access new resources. We invest all the money we raise to build sustainable and community-based projects around Colombia. Our team works closely to ensure that every dollar is accounted for and provides reports back to our donors. Through our programs we aim to teach and empower. ")
  ])
], -1))
const _hoisted_2 = {
  class: "third scroll-to",
  id: "women_education"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "story-telling" }
const _hoisted_5 = { class: "teachings" }
const _hoisted_6 = { class: "conclusion" }
const _hoisted_7 = {
  class: "fourth scroll-to",
  id: "children_education"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_9 = { class: "story-telling" }
const _hoisted_10 = { class: "teachings" }
const _hoisted_11 = { class: "conclusion" }
const _hoisted_12 = {
  class: "fifth scroll-to",
  id: "food-home"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_sticky_button = _resolveComponent("lp-sticky-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.womenEducationProgram.title), 1),
      _hoisted_3,
      _createElementVNode("article", null, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.womenEducationProgram.storyTelling[0]), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.womenEducationProgram.storyTelling[1]), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.womenEducationProgram.description.teachings, (teaching) => {
            return (_openBlock(), _createElementBlock("span", {
              key: teaching.title
            }, [
              _createElementVNode("strong", null, _toDisplayString(teaching.title) + ":", 1),
              _createElementVNode("p", null, _toDisplayString(teaching.description), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.womenEducationProgram.conclusion), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.childrenEducationProgram.title), 1),
      _hoisted_8,
      _createElementVNode("article", null, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_ctx.childrenEducationProgram.storyTelling[0]), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.childrenEducationProgram.storyTelling[1]), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenEducationProgram.description.teachings, (teaching) => {
            return (_openBlock(), _createElementBlock("span", {
              key: teaching.title
            }, [
              _createElementVNode("strong", null, _toDisplayString(teaching.title) + ":", 1),
              _createElementVNode("p", null, _toDisplayString(teaching.description), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.childrenEducationProgram.conclusion), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.foodHomeForChildren.title), 1),
      _hoisted_13,
      _createElementVNode("article", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.foodHomeForChildren.description[0]), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.foodHomeForChildren.description[1]), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.foodHomeForChildren.description[2]), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.foodHomeForChildren.description[3]), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.foodHomeForChildren.description[4]), 1)
      ]),
      _createVNode(_component_lp_button, {
        size: "large",
        type: "fill",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/donate" }, {
            default: _withCtx(() => [
              _createTextVNode("CONTRIBUTE")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_lp_sticky_button)
  ]))
}